'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  dialog: {
    width: '80%',
    maxWidth: '360px',
    margin: '0 auto',
    backgroundColor: _colors2.default.theme,
    color: _colors2.default.white,
    borderRadius: '4px',
    padding: '40px 30px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxShadow: _styles2.default.depthShadows[0],
    overflow: 'auto',
    transition: 'background .3s ease-in-out',
    fontSize: '16px'
  },
  header: {
    color: 'inherit',
    fontSize: '24px',
    fontWeight: 'bolder',
    margin: '0 0 16px'
  },
  closeButton: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    zIndex: 1
  },
  clickAway: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    cursor: 'pointer'
  }
};
module.exports = exports.default;